import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from "axios";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import mainlogo from "../../Images/vantaralogo.png";
const LoginModal = ({ show, handleClose, handleLoginSuccess }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const location = useLocation();
  const from = window.location.pathname;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://vantara.datacubeglobal.com/api/login", {
        mobile: formData.mobile,
        password: formData.password,
      });

      if (res.data.status === "success") {

        sessionStorage.setItem("userData", JSON.stringify(res.data));


        handleClose();

        Swal.fire({
          icon: "success",
          title: "Login successful!",
          confirmButtonColor: "#1c3f1d",
          confirmButtonText: "OK",
        });


        const from = window.location.pathname;
        navigate(from, { replace: true });
      } else {

        Swal.fire({
          icon: "error",
          title: "Login failed!",
          text: res.data.message || "Invalid credentials",
          confirmButtonColor: "#1c3f1d",
        });
      }
    } catch (err) {
      // Network or unexpected errors
      Swal.fire({
        icon: "error",
        title: "Login failed!",
        text: err.response?.data?.message || "Something went wrong",
        confirmButtonColor: "#1c3f1d",
      });
      console.error(err);
    }
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-4 shadow-lg">
          <div className="modal-header border-0 justify-content-center">
            <div
              className="modal-title text-center fw-bold"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <img
                src={mainlogo}
                alt="Logo"
                style={{ maxHeight: "50px", objectFit: "contain" }}
              />
              <div
                style={{
                  fontSize: "1rem",
                  color: "black",
                  fontWeight: "500",
                  textAlign: "center",
                  marginTop: "5px",
                }}
              >
                Please login !
              </div>
            </div>


            <button
              type="button"
              className="btn-close position-absolute end-0 me-3"
              onClick={handleClose}
            ></button>
          </div>

          <div className="modal-body px-4">
            <form onSubmit={handleSubmit}>

              <div className="mb-3">
                <input
                  type="number"
                  className="form-control form-control-lg"
                  placeholder="mobile*"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </div>


              <div className="mb-3 position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control form-control-lg pe-5"
                  placeholder="Password*"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <span
                  className="position-absolute end-0 top-50 translate-middle-y me-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  <i
                    className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"
                      }`}
                  ></i>
                </span>
              </div>

              {/* Submit */}
              <div className="d-flex justify-content-center mt-4">
                <button
                  type="submit"
                  className="btn rounded-pill px-5 py-2 fw-bold"
                  style={{
                    background: "linear-gradient(135deg, #7c0046, #1c3f1d)",
                    color: "#fff",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                    transition: "0.3s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.background = "linear-gradient(135deg, #1c3f1d, #7c0046)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.background = "linear-gradient(135deg, #7c0046, #1c3f1d)")
                  }
                >
                  Login
                </button>
              </div>
            </form>
          </div>

          <div className="modal-footer border-0 justify-content-center">
            <p className="text-muted mb-0">
              Don’t have an account?{" "}
              <a href="/register" className="text-decoration-none">
                Register
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
